import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { LangProvider } from './lang/lang';
import { SomeProvider } from './some/some';

@Injectable({ providedIn: 'root' })
export class LogoutConfirmationService {
  constructor(
    private alertController: AlertController,
    private lingua: LangProvider,
    private myService: SomeProvider,
    private router: Router
  ) { }

  async confirmLogout(onBeforePrompt?: () => void): Promise<void> {
    if (onBeforePrompt) {
      onBeforePrompt();
    }

    const lang = this.lingua.languageSelected || 'IT';
    const suffix = `_${lang}`;

    const annullaLabel = this.getTranslated(`annullaLabel${suffix}`, 'Annulla');
    const confermaLabel = this.getTranslated(`confermaLabel${suffix}`, 'Conferma');
    const header = this.getTranslated(`logoutAlertHeader${suffix}`, 'Conferma logout');
    const message = this.getTranslated(`logoutAlertMessage${suffix}`, 'Sei sicuro di voler effettuare il logout?');

    const alert = await this.alertController.create({
      header,
      message,
      buttons: [
        {
          text: annullaLabel,
          role: 'cancel'
        },
        {
          text: confermaLabel,
          handler: () => {
            void this.logout();
          }
        }
      ]
    });

    await alert.present();
  }

  async logout(onBeforeLogout?: () => void): Promise<void> {
    if (onBeforeLogout) {
      onBeforeLogout();
    }

    this.myService.logout();
    await this.router.navigate(['/welcome']);
  }

  private getTranslated(key: string, fallback: string): string {
    const value = this.lingua[key];
    return typeof value === 'string' && value.trim().length > 0 ? value : fallback;
  }
}
